import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { SideBar } from "../../components";
import {
  getBreakdown,
  getDashboard,
  getEfisiensi,
  getHrPeriod,
  getKualitasData,
  getTren,
} from "../../config/redux/action/sustainabilityAction";
import { periodeSekarang } from "../../utils";
import PanelHeadline from "./PanelHeadline";
import PanelSavings from "./PanelSavings";
import PanelKonsumsi from "./PanelKonsumsi";
import PanelChemical from "./PanelChemical";
import PanelEfisiensi from "./PanelEfisiensi";
import PanelSocial from "./PanelSocial";
import PanelKualitas from "./PanelKualitas";
import PanelDrilldown from "./PanelDrilldown";
import TrenChart from "./TrenChart";

function Panel({ nomor, judul, keterangan, children }) {
  return (
    <Card className="mb-3 border-0 shadow-sm">
      <Card.Body className="p-3">
        <div className="mb-2">
          <div className="fw-bold" style={{ fontSize: "14px" }}>
            {nomor}. {judul}
          </div>
          {keterangan && (
            <div className="text-muted" style={{ fontSize: "11px" }}>
              {keterangan}
            </div>
          )}
        </div>
        {children}
      </Card.Body>
    </Card>
  );
}

function SustainabilityDashboardPage() {
  const {
    DashboardData,
    TrenData,
    EfisiensiData,
    KualitasData,
    BreakdownData,
    HrPeriod,
  } = useSelector((state) => state.sustainabilityReducer);

  const [Periode, setPeriode] = useState(periodeSekarang());
  const [Scope, setScope] = useState("company");
  const [Dimensi, setDimensi] = useState("program");
  const [KodeTren, setKodeTren] = useState("");
  const [UpdateHr, setUpdateHr] = useState(1);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!Periode) return;
    dispatch(getDashboard(Periode, Scope)).catch((err) => console.log(err));
    dispatch(getEfisiensi(Periode)).catch((err) => console.log(err));
    dispatch(getKualitasData(Periode)).catch((err) => console.log(err));
  }, [Periode, Scope]);

  useEffect(() => {
    if (!Periode) return;
    dispatch(getTren(12, KodeTren, Periode, Scope)).catch((err) =>
      console.log(err)
    );
  }, [Periode, Scope, KodeTren]);

  useEffect(() => {
    if (!Periode) return;
    dispatch(getBreakdown(Periode, Dimensi)).catch((err) => console.log(err));
  }, [Periode, Dimensi]);

  useEffect(() => {
    dispatch(getHrPeriod(12)).catch((err) => console.log(err));
  }, [UpdateHr]);

  const panelSavings = DashboardData?.panel_savings || [];
  const panelKonsumsi = DashboardData?.panel_konsumsi || [];
  const panelChemical = DashboardData?.panel_chemical || [];
  const panelEfisiensi = DashboardData?.panel_efisiensi || [];
  const daftarKodeTren = [...panelSavings, ...panelKonsumsi, ...panelEfisiensi];

  return (
    <div>
      <SideBar />
      <div className="content px-1">
        <Card className="mb-3 border-0 shadow-sm">
          <Card.Body className="p-3 d-flex flex-wrap align-items-end">
            <div className="me-3 mb-1">
              <label className="form-label fw-bold mb-1" style={{ fontSize: "11px" }}>
                Periode
              </label>
              <input
                type="month"
                className="form-control form-control-sm"
                style={{ fontSize: "12px", width: 160 }}
                value={Periode}
                onChange={(e) => setPeriode(e.target.value)}
              />
            </div>
            <div className="me-3 mb-1">
              <label className="form-label fw-bold mb-1" style={{ fontSize: "11px" }}>
                Scope
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                style={{ fontSize: "12px", width: 200 }}
                placeholder="company atau workshop:1"
                value={Scope}
                onChange={(e) => setScope(e.target.value)}
              />
            </div>
            <div className="text-muted mb-2" style={{ fontSize: "10px" }}>
              Scope <code>company</code> untuk agregat seluruh perusahaan; gunakan
              format <code>workshop:&lt;id&gt;</code>, <code>service:&lt;jenis&gt;</code>,{" "}
              <code>machine:&lt;id&gt;</code> untuk cakupan yang lebih sempit.
            </div>
          </Card.Body>
        </Card>

        {/* Susunan bagian 13 dokumen alur: ORDERS, indikator lingkungan
            utama, lalu blok social impact. */}
        <Panel
          nomor={0}
          judul="Nyonyaa Impact Dashboard"
          keterangan="Ringkasan periode: jumlah order, indikator lingkungan utama, dan social impact level perusahaan."
        >
          <PanelHeadline
            totalOrder={DashboardData?.total_order}
            items={DashboardData?.panel_headline}
            social={DashboardData?.panel_social}
            socialItems={DashboardData?.panel_social_items}
          />
        </Panel>

        <Panel
          nomor={1}
          judul="Headline Savings"
          keterangan="Penghematan terhadap baseline pada periode terpilih. Badge tier menunjukkan kualitas data di balik angka."
        >
          <PanelSavings
            items={panelSavings}
            baselineDipakai={DashboardData?.baseline_dipakai}
          />
        </Panel>

        <Panel
          nomor={2}
          judul="Konsumsi"
          keterangan="Angka absolut dan intensitas ditampilkan berdampingan agar pertumbuhan volume tidak tertukar dengan penurunan efisiensi."
        >
          <PanelKonsumsi items={panelKonsumsi} />

          <div className="fw-bold mt-4 mb-2" style={{ fontSize: "13px" }}>
            Jenis chemical yang digunakan
          </div>
          <PanelChemical items={panelChemical} />
        </Panel>

        <Card className="mb-3 border-0 shadow-sm">
          <Card.Body className="p-3">
            <div className="fw-bold mb-2" style={{ fontSize: "14px" }}>
              Tren 12 Periode
            </div>
            <TrenChart
              data={TrenData}
              kode={KodeTren}
              onChangeKode={setKodeTren}
              daftarKode={daftarKodeTren}
            />
          </Card.Body>
        </Card>

        <Panel
          nomor={3}
          judul="Efisiensi Operasi"
          keterangan="Rewash rate, utilisasi mesin, reject rate, dan waktu proses, beserta estimasi kerugian rupiah akibat rewash."
        >
          <PanelEfisiensi items={panelEfisiensi} efisiensi={EfisiensiData} />
        </Panel>

        <Panel
          nomor={4}
          judul="Social Impact"
          keterangan="Data ketenagakerjaan per periode. Diisi manual karena tidak berasal dari data order."
        >
          <PanelSocial
            periode={Periode}
            list={HrPeriod}
            onSaved={() => setUpdateHr(UpdateHr + 1)}
          />
        </Panel>

        <Panel
          nomor={5}
          judul="Data Quality"
          keterangan="Komposisi tier, kelengkapan data, dan indikator yang ditahan sistem karena tier minimum belum terpenuhi."
        >
          <PanelKualitas data={KualitasData} />
        </Panel>

        <Panel
          nomor={6}
          judul="Drill-down"
          keterangan="Pecah dampak periode berdasarkan dimensi operasional untuk menemukan sumber perbedaan."
        >
          <PanelDrilldown
            by={Dimensi}
            onChangeBy={setDimensi}
            data={BreakdownData}
          />
        </Panel>
      </div>
    </div>
  );
}

export default SustainabilityDashboardPage;
